
import React from "react";
import UserContext from 'context/UserContext';
import { withStyles, Box, Typography, InputBase, Divider, Button } from "@material-ui/core";
import _ from 'lodash';
import HylyButton from "storybookComponents/Button";
import CampaignList from "./List";
import Header from "components/Header";
import SearchBox from "components/SearchBox";
import Loader from "storybookComponents/Loader";
import { getCreateEventPath } from "constants/path"
import styles from "./style";
import NoCampaignIcon from "images/b-check.svg";
import { getCampaigns } from "relay/campaigns"
import toggleCampaign from "relay/campaigns/mutations/toggleCampaign.js";
import duplicateCampaign from "relay/campaigns/mutations/duplicateCampaign.js";
import environment from "environments/environment.js";
import ToastMessage from "storybookComponents/Toast";
import Icon from "storybookComponents/Icon"
import { getErrorMessage, checkUncatchableError } from "environments/uncatchableErrorStore";

const statusValue = {
  "all": "all",
  "active": "active",
  "inactive": "non_active"
}

const CampaignsList = withStyles(styles)(({
  classes,
  history,
  setTitle,
  setActive,
  orgLevel,
  setOriginNavItems
}) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [campaigns, setCampaigns] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [noEventText, setNoEventText] = React.useState('No campaigns available. ');
  const [toast, setToast] = React.useState({ open: false })
  const [pageInfo, setPageInfo] = React.useState();
  const [moreLoading, setMoreLoading] = React.useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [status, setStatus] = React.useState([]);
  const [search, setSearch] = React.useState("");
  // set the header bar title
  React.useEffect(() => {
    setTitle('Referral Campaigns');
    setActive('Referral Campaigns');
    if (orgLevel) {
      setOriginNavItems("hyRafMenuOrg")
    } else {
      setOriginNavItems("hyRaf")
    }
  }, [orgLevel]);

  const onClickNewCampaign = () => {
    history.push(getCreateEventPath());
    window.scrollTo(0, 0);
  };

  const loadMoreClick = () => {
    loadCampaigns(
      search,
      true,
      pageInfo.startCursor,
      status
    );
  }

  const loadCampaigns = async (search, reload, before, status, last = 30) => {
    let _status = status ? status.length != 1 ? "all" : statusValue[status[0]] : "all"
    try {
      if (reload) {
        await setMoreLoading(true)
      } else {
        await setLoading(true);
      }
      const response = await getCampaigns(subOrgDetails.org.id, orgLevel ? "" : subOrgDetails.id, search, before, last, _status);
      if (response && response.sorted) {
        setPageInfo(response.pageInfo)
        if (reload) {
          setCampaigns([...campaigns, ...response.sorted]);
        } else {
          setCampaigns(response.sorted);
        }

        if (reload) {
          await setMoreLoading(false)
        } else {
          await setLoading(false);
        }
      }
    } catch (err) {
      console.log("Err", err)
    }
  }


  const handleActiveClick = async (campaign, prev) => {
    try {
      let response = await toggleCampaign(environment, { id: campaign.id });
      if (response && response.toggleHyreferralCampaign) {
        let active = response.toggleHyreferralCampaign.hyreferralCampaign.active;
        showNotification(`${campaign.title} is ${active ? 'activated' : 'deactivated'} now successfully`, "success")
        return active;
      }
      else {
        showNotification(`Something went wrong`, "error");
        return prev;
      }
    } catch (err) {
      const uncachebleError = getErrorMessage(checkUncatchableError("toggleCampaignMutation"));
      showNotification(uncachebleError || `Something went wrong`, "error");
      return prev;
    }
  }

  const onDuplicateCallback = async (item) => {
    try {
      setLoading(true);
      let response = await duplicateCampaign(environment, { id: item.id });
      if (response && response.duplicateHyreferralCampaign) {
        let campaign = response.duplicateHyreferralCampaign.hyreferralCampaign;
        setCampaigns([{ node: campaign }, ...campaigns]);
        showNotification(`A copy of ${item.title} has been created.`, "success");
      } else {
        showNotification(`Something went wrong`, "error");
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const uncachebleError = getErrorMessage(checkUncatchableError("duplicateCampaignMutation"));
      showNotification(uncachebleError || `Something went wrong`, "error");
    }
  }

  const handleSearch = (value) => {
    setSearch(value);
    loadCampaigns(
      value,
      false,
      null,
      status)
  }

  const handleFilter = (value) => {
    setStatus(value);
    loadCampaigns(
      search,
      false,
      null,
      value)
  }

  const noCampaignsView = () => {
    return (
      <tr>
        <td colSpan={5}>
          <div className={classes.noEventsWrapper}>
            <div>
              <img src={NoCampaignIcon} className={classes.imageOpacity} width="80px" height="80px" alt="No Campaigns" />
              {
                (status.length === 1 || search !== "") ? <Typography variant="h6" className={classes.noEventsText}>No campaigns available for the selected filter.</Typography> :
                  <Typography variant="h6" className={classes.noEventsText}>{noEventText} Click <strong>‘+ Referral Campaign’</strong> button to create new</Typography>
              }
            </div>
          </div>
        </td>
        <td colSpan={3} className={classes.remainingRowWidth}></td>
      </tr>

    )
  }

  const renderCampaignsList = () => {
    return <Box my={2} className={classes.eventsListWrapper}>
      <CampaignList
        noCampaignsView={noCampaignsView}
        showFilter={showFilter}
        status={status}
        handleFilter={handleFilter}
        campaigns={campaigns}
        history={history}
        onActiveClick={handleActiveClick}
        onDuplicateCallback={onDuplicateCallback}
      />
      {
        (pageInfo && pageInfo.hasPreviousPage) ? <div className={classes.loadMore} onClick={moreLoading ? () => { } : loadMoreClick}>{moreLoading ? "Loading..." : "Load More"}</div> : null
      }
    </Box>
    // }
  }

  const closeToast = () => {
    setTimeout(() => {
      setToast({
        open: false,
        variant: toast.variant
      })
    }, 5000)
  }

  const forceCloseToast = () => {
    setToast({
      open: false,
      variant: toast.variant
    })
  }

  const showNotification = (message, type) => {
    setToast({
      open: true,
      variant: type,
      message
    })
  }

  const handleShowFilter = () => {
    setShowFilter(!showFilter)
  }





  React.useEffect(() => {
    loadCampaigns(
      search,
      false,
      null,
      status)
  }, [orgLevel]);


  return (
    <>
      <Header
        title="Referral Campaigns List"
      >
        <Box display="flex" alignItems="center">
          <>
            <div onClick={handleShowFilter} className={`${showFilter && classes.filterEnableClass} ${classes.filterClass}`}> <Icon type="icon-filter-tool" size="sm" />
            </div>
            <Divider orientation="vertical" flexItem className={classes.verticalDivider} />
            <SearchBox
              onSearch={handleSearch}
              className={classes.searchBox}
            />
            <Divider orientation="vertical" flexItem className={classes.verticalDivider} />
          </>


          <HylyButton color="hylyBlue" type="submit" variant="primary" size="sm" className={classes.newEventButton} onClick={onClickNewCampaign} >
            <div className={classes.newButton}>
              + Referral Campaign
          </div>
          </HylyButton>
        </Box>
      </Header>
      <ToastMessage
        variant={toast.variant}
        message={toast.message}
        open={toast.open}
        onCloseCallback={closeToast}
        onForceCloseCallback={forceCloseToast}
      />
      <div className={classes.root}>
        <div className={classes.eventListWrapper}>
          {loading ? <Loader /> : renderCampaignsList()}
        </div>
      </div>
    </>
  )
});

export default CampaignsList;
